module.exports = __webpack_public_path__ + "static/media/HomeRoll_Walls_AluCladdWall.37392630.jpg";